import SpecialtiesTableContainer from './SpecialtiesTableContainer';

export default SpecialtiesTableContainer;
